import logo from "../../assets/img/logo.svg";
import whiteLogo from "../../assets/img/logo-white.svg";
import css from "../../styles/GlyMedLogo.module.css";

const GlyMedLogo = ({ color, styles = {} }) => {
  if (color === "white") {
    return (
      <img
        style={{ ...styles }}
        src={whiteLogo}
        alt="logo"
        className={css["logo"]}
      />
    );
  }
  return (
    <img style={{ ...styles }} src={logo} alt="logo" className={css["logo"]} />
  );
};

export default GlyMedLogo;
